import Vue from "vue";
import VueI18n from "vue-i18n";
import enModules from "@/locales/en/modules.json";
import esModules from "@/locales/es/modules.json";
import enText from "@/locales/en/text.json";
import esText from "@/locales/es/text.json";
import { flattenModuleMessages } from "@/locales/flatten-module-messages";

Vue.use(VueI18n);

const messages = {
    en: {
        ...enText,
        noData: "No Data",
        embed: {
            noSensorData: "No sensor data available for this station.",
            loadFailed: "Failed to load chart data.",
            loginRequired: "You need to be logged in on the FieldKit portal to view this data.",
            accessDenied: "You do not have access to view this station.",
            login: "Log in",
            missingStation: "Missing station parameter.",
            queryParamsTitle: "Embed parameters",
            paramLines: {
                tools: "<strong>tools</strong>: set to 1 to show this helper panel. Do not include it in partner iframe code.",
                station: "<strong>station</strong>: required station ID.",
                sensors:
                    "<strong>sensors</strong>: optional comma-separated sensor IDs. When omitted, the embed shows the station's module charts in the same order as the station page.",
                limit: "<strong>limit</strong>: optional number of charts to show, from 1 to 4. Defaults to 4.",
                lang: "<strong>lang</strong>: optional language code: en or es. Defaults to en.",
                title: "<strong>title</strong>: set to 0 to hide chart headings. Defaults to 1 (visible).",
                branding: "<strong>branding</strong>: set to 0 to hide the Powered by FieldKit footer. Defaults to 1 (visible).",
            },
            poweredBy: {
                before: "Powered by ",
                brand: "FieldKit",
            },
            iframeTitle: "FieldKit data view",
            map: {
                missingProject: "Missing project parameter.",
                loadFailed: "Failed to load project map.",
                accessDenied: "You do not have access to view this project.",
                iframeTitle: "FieldKit project map",
                paramLines: {
                    project: "<strong>project</strong>: required project ID.",
                },
            },
        },
        ...flattenModuleMessages(enModules),
    },
    es: {
        ...esText,
        noData: "No hay datos",
        embed: {
            noSensorData: "No hay datos de sensores disponibles para esta estación.",
            loadFailed: "No se pudieron cargar los datos del gráfico.",
            loginRequired: "Debes iniciar sesión en el portal FieldKit para ver estos datos.",
            accessDenied: "No tienes acceso para ver esta estación.",
            login: "Iniciar sesión",
            missingStation: "Falta el parámetro de la estación.",
            queryParamsTitle: "Parámetros de incrustación",
            paramLines: {
                tools: "<strong>tools</strong>: usa 1 para mostrar este panel de ayuda. No lo incluyas en el código iframe para partners.",
                station: "<strong>station</strong>: ID de estación obligatorio.",
                sensors:
                    "<strong>sensors</strong>: IDs de sensores opcionales separados por comas. Si se omiten, el widget muestra los gráficos de módulos de la estación en el mismo orden que la página de la estación.",
                limit: "<strong>limit</strong>: número opcional de gráficos para mostrar, de 1 a 4. El valor predeterminado es 4.",
                lang: "<strong>lang</strong>: código de idioma opcional: en o es. El valor predeterminado es en.",
                title: "<strong>title</strong>: usa 0 para ocultar los títulos de los gráficos. El valor predeterminado es 1 (visible).",
                branding:
                    "<strong>branding</strong>: usa 0 para ocultar el pie de página Powered by FieldKit. El valor predeterminado es 1 (visible).",
            },
            poweredBy: {
                before: "Desarrollado por ",
                brand: "FieldKit",
            },
            iframeTitle: "Vista de datos de FieldKit",
            map: {
                missingProject: "Falta el parámetro del proyecto.",
                loadFailed: "No se pudo cargar el mapa del proyecto.",
                accessDenied: "No tienes acceso para ver este proyecto.",
                iframeTitle: "Mapa del proyecto FieldKit",
                paramLines: {
                    project: "<strong>project</strong>: ID de proyecto obligatorio.",
                },
            },
        },
        ...flattenModuleMessages(esModules),
    },
};

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || "en",
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
    messages,
    silentTranslationWarn: true,
});
